// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  renditionId: __t.u64().primaryKey().name("rendition_id"),
  assetId: __t.u64().name("asset_id"),
  settingsJson: __t.string().name("settings_json"),
  updatedBy: __t.identity().name("updated_by"),
  updatedAt: __t.timestamp().name("updated_at"),
});
